// Externe Bibliotheken
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Interne Module
import { getDate, getParticipants } from '@/_helper/bookingDetailsHelper';

const Excursion = (props) => {
    const item = props.item;
    const title = item.title ?? item.description.split(' -')[0];

    return (
        <section className="card">
            <div className="card-row">
                <div className="image-sec">
                    {item.image !== undefined && (
                        <LazyLoadImage
                            wrapperClassName="lazy-load-background"
                            src={item.image}
                            alt={`Bild des Ausflugs "${title}"`}
                            effect="blur"
                        />
                    )}
                </div>
                <h2>Ausflug "{title}"</h2>
            </div>
            <div className="card-row space-between">
                <div>Ausflugsdatum</div>
                <div>{getDate(item)}</div>
            </div>
            <div className="card-row space-between">
                <div>Teilnehmende</div>
                <div className="txtR">{getParticipants(item)}</div>
            </div>
            <hr />
            <div className="card-row space-between">
                <div>Ursprünglicher Reisepreis</div>
                <div>{props.prices.packagePrice}</div>
            </div>
            <div className="card-row space-between">
                <div>Neuer Reisepreis abzüglich Ausflug</div>
                <div>{props.prices.newPackagePrice}</div>
            </div>
            <hr />
            <div className="card-row space-between text-bold">
                <div>Rückerstattung Ausflug</div>
                <div>{props.prices.refundValue}</div>
            </div>
        </section>
    );
};

export default Excursion;
